<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formVisit">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [severity]="null" (onClick)="goToBack($event)"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>
          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>
            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
      </div>
      <div class="row p-2">
        <div class="row">
          <div class="col field-branch">
            <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
              [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
          </div>
          <div class="col field-consecutive">
            <app-custom-input-number formControlName="consecutive" [labelText]="'Consecutivo'" [recovery]="true"
              (onChangeNumber)="changeConsecutive($event)"></app-custom-input-number>
          </div>
          <div class="col field-date-scheduled">
            <app-custom-datepicker formControlName="dateScheduled" [labelText]="'Fecha Programada'"
              [required]="true"></app-custom-datepicker>
          </div>
          <div class="col field-date-executed">
            <app-custom-datepicker formControlName="dateExecuted"
              [labelText]="'Fecha Ejecución'"></app-custom-datepicker>
          </div>
          <div class="col field-state-text">
            <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
          </div>
          <div class="col field-change-state d-flex align-items-end gap-2">
            <app-custom-button [icon]="'pi pi-undo'" [title]="'Reversar estado'" [severity]="'primary'"
              [disabled]="disableReverseState" (onClick)="revertState()"></app-custom-button>
            <app-custom-button [title]="titleStateCancel" [icon]="iconStateCancel" [severity]="severityCancel"
              [disabled]="false" (onClick)="openCancelVisitModal()"></app-custom-button>
            <app-custom-modal #cancelVisitModal [label]="'Cancelar Visita Programada'" [width]="'25rem'"
              [header]="'Cancelar Visita Programada'" [inputs$]="inputsForCancelVisitModals$"
              [children]="componentCancelVisitModal" (params)="reloadVisit($event.reload)" hidden>
            </app-custom-modal>
          </div>
          <div class="col field-sw-block">
            <app-custom-checkbox formControlName="swBlock" [labelText]="'Bloq.'"
              (onChangeCheckBox)="blockVisit($event)"></app-custom-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col field-client">
            <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClients"
              (onChangeSelect)="changeClient($event)"></app-custom-autocomplete>
          </div>
          <div class="col field-client-visit">
            <app-custom-input-text formControlName="clientVisit" [labelText]="'Cliente Visita'"
              [maxLength]="70"></app-custom-input-text>
          </div>
          <div class="col field-cost-center">
            <app-custom-autocomplete formControlName="costCenterId" [labelText]="'C.Costos'" [list]="listCostCenters"
              (onChangeSelect)="changeCostCenter($event)"></app-custom-autocomplete>
          </div>
          <div class="col field-construction-site-visit">
            <app-custom-input-text formControlName="constructionSiteVisit" [labelText]="'C.Costos Visita'"
              [maxLength]="70" (onChangeText)="changeConstructionSiteVisit($event)"></app-custom-input-text>
          </div>
        </div>
        <div class="row">
          <div class="col field-sw-new-construction-site">
            <app-custom-tag [value]="visitContract.swNewConstructionSite ? 'NUEVO' : 'ANTIGUO'"
              [label]="'Tipo C.Costos'"></app-custom-tag>
          </div>
          <div class="col field-zone">
            <app-custom-select formControlName="zoneId" [labelText]="'Zona'" [list]="listZones"
              [required]="true"></app-custom-select>
          </div>
          <div class="col field-construction-site-address">
            <app-custom-input-text formControlName="constructionSiteAddress" [labelText]="'Dirección'" [required]="true"
              [maxLength]="70"></app-custom-input-text>
          </div>
          <div class="col field-contact">
            <app-custom-input-text formControlName="contact" [labelText]="'Contacto'" [required]="true"
              [maxLength]="70"></app-custom-input-text>
          </div>
        </div>
        <div class="row">
          <div class="col field-position">
            <app-custom-input-text formControlName="position" [labelText]="'Cargo'"
              [maxLength]="70"></app-custom-input-text>
          </div>
          <div class="col field-phone1">
            <app-custom-input-text formControlName="phone1" [labelText]="'Teléfono 1'"
              [maxLength]="15"></app-custom-input-text>
          </div>
          <div class="col field-phone2">
            <app-custom-input-text formControlName="phone2" [labelText]="'Teléfono 2'"
              [maxLength]="15"></app-custom-input-text>
          </div>
          <div class="col field-email">
            <app-custom-input-text formControlName="email" [labelText]="'Correo'"
              [maxLength]="50"></app-custom-input-text>
          </div>
        </div>
        <div class="row">
          <div class="col field-seller">
            <app-custom-autocomplete formControlName="sellerId" [labelText]="'Asesor'" [list]="listSellers"
              [required]="true"></app-custom-autocomplete>
          </div>
          <div class="col field-sw-quote">
            <app-custom-select formControlName="swQuote" [labelText]="'Cotizar'"
              [list]="listQuotes"></app-custom-select>
          </div>
        </div>
        <div class="row">
          <div class="col field-initial-goal">
            <app-custom-textarea formControlName="initialGoal" [labelText]="'Objetivo Inicial'" [required]="true"
              [autoResize]="false" [rows]="1" [maxLength]="1000"></app-custom-textarea>
          </div>
          <div class="col field-result">
            <app-custom-textarea formControlName="result" [labelText]="'Resultado Final'" [autoResize]="false"
              [rows]="1" [maxLength]="1000"></app-custom-textarea>
          </div>
          <div class="col field-save d-flex align-items-end mt-1">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
              [disabled]="disabledForm" (onClick)="send()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>